// GA4 config — fires early but non-blocking
document.addEventListener('DOMContentLoaded', function(){
  gtag('js', new Date());
  gtag('config', 'G-19BYZ1N7VH', {
    send_page_view: true,
    linker: { domains: ['klaracosmetics.com','checkout.shopify.com'] },
    transport_type: 'beacon' // page unload pe bhi reliably send
  });

  // If early UTM cached, ensure we send the event (in case head queue missed)
  if (window.__utmStore && Object.keys(window.__utmStore).length){
    gtag('event', 'utm_parameters_detected', window.__utmStore);
  }
});
